import { module } from 'modujs';
import VueProductGallery from '../vue/components/VueProductGallery';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init events
        this.bindEvents();

        // Init vue
        this.initVue()
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
        this.app?.$destroy?.()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind);
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind);
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.app?.$refs?.gallery.onResize?.()
    }

    onProductVariantChange(productVariantId) {
        this.app?.$refs?.gallery?.onProductVariantChange?.(productVariantId)
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Components
        VueProductGallery(moduleInstance)

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }
}
